<template>
    <div>
        <video-filter :videos.sync="videos" :pagination-data.sync="paginationData" ref="filter"></video-filter>

        <static-loading-indicator-icon/>
        <div v-if="!$store.getters.shouldLoadLocal" class="mt-3">
            <div v-if="videos.length">
                <div class="alert alert-secondary border-dark">
                    {{ $t('pages.admin.video.select.explanation') }}
                </div>
                <div class="row">
                    <div class="col-md-3 col-12 cursor-pointer" v-for="video in videos" v-if="videos.length"
                         @dblclick="$emit('select', video.id)">

                        <gym-video-card :video="video" :show-progress="false"
                                        :show-like="false" :show-completed="false"
                                        :hover-effect-enabled="false" :key="video.id">
                        </gym-video-card>
                    </div>
                </div>
                <div class="mt-3">
                    <pagination :data="paginationData" @pagination-change-page="loadPage"></pagination>
                </div>
            </div>
            <div class="alert alert-secondary border-dark" v-else>
                {{ $t('pages.admin.video.index.none_found') }}
            </div>
        </div>
    </div>
</template>

<script>
import AdminVideoRepository from "../../../../repositories/Admin/AdminVideoRepository";
import GymVideoCard from "../../../Gym/Includes/GymVideoCard";
import StaticLoadingIndicatorIcon from "../../../Includes/StaticLoadingIndicatorIcon";
import VideoFilter from "./VideoFilter";

export default {
    name: "VideoSelector",
    components: {VideoFilter, StaticLoadingIndicatorIcon, GymVideoCard},
    data: () => ({
        videos: [],
        paginationData: {},
    }),
    props: {
        excludedSeriesId: {
            type: Number,
            default: undefined
        }
    },
    mounted() {
    },
    methods: {
        loadPage(page) {
            this.$refs.filter.getVideos(page);
        }
    }
}
</script>

<style scoped>

</style>
